var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from "react";
import { Box, Button, Grid, Typography, Card, Avatar } from "@mui/material";
import { CloudUpload, AddPhotoAlternate } from "@mui/icons-material";
export var Upload = function (_a) {
    var onUpload = _a.onUpload;
    var _b = useState(null), selectedFile = _b[0], setSelectedFile = _b[1];
    var handleFileChange = function (event) {
        var files = event.target.files;
        onUpload(files ? (files[0] ? files : null) : null);
        var file = event.target.files ? event.target.files[0] : null;
        setSelectedFile(file);
    };
    var handleDrop = function (event) {
        event.preventDefault();
        var files = event.dataTransfer.files;
        setSelectedFile(files[0]);
        onUpload(files);
    };
    var handleDragOver = function (event) {
        event.preventDefault();
    };
    var StepIcon = function (_a) {
        var stepNumber = _a.stepNumber;
        return (_jsx(Avatar, __assign({ sx: {
                backgroundColor: "#1976d2",
                width: 40,
                height: 40,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            } }, { children: _jsx(Typography, __assign({ variant: "h6", sx: { color: "white" } }, { children: stepNumber })) })));
    };
    return (_jsx(Box, { children: _jsx(Card, __assign({ sx: {
                py: 2,
                px: 6,
            } }, { children: _jsxs(Grid, __assign({ container: true }, { children: [_jsxs(Box, __assign({ display: "flex", alignItems: "center", mb: 2 }, { children: [_jsx(StepIcon, { stepNumber: 1 }), _jsx(Typography, __assign({ ml: 2, variant: "h6" }, { children: "Fazer upload de uma foto" }))] })), _jsx(Box, __assign({ sx: {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "2px dashed #ccc",
                            borderRadius: "8px",
                            padding: "16px",
                            width: "100%",
                            maxWidth: "400px",
                            textAlign: "center",
                            backgroundColor: "#f9f9f9",
                            transition: "background-color 0.3s",
                            "&:hover": {
                                backgroundColor: "#f0f0f0",
                            },
                        }, onDrop: handleDrop, onDragOver: handleDragOver }, { children: !selectedFile ? (_jsxs(_Fragment, { children: [_jsx(AddPhotoAlternate, { sx: { fontSize: 48, color: "#777" } }), _jsx(Typography, __assign({ variant: "body1", sx: { marginY: 2 } }, { children: "Arraste e solte uma imagem aqui ou clique para selecionar" })), _jsxs(Button, __assign({ variant: "contained", startIcon: _jsx(CloudUpload, {}), component: "label" }, { children: ["Selecionar Arquivo", _jsx("input", { type: "file", accept: "image/*", hidden: true, onChange: handleFileChange })] }))] })) : (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: "h6", sx: { marginBottom: 2 } }, { children: "Arquivo selecionado:" })), _jsx(Typography, __assign({ variant: "body2", sx: { fontStyle: "italic" } }, { children: selectedFile.name })), _jsx(Button, __assign({ variant: "outlined", color: "error", sx: { marginTop: 2 }, onClick: function () { return setSelectedFile(null); } }, { children: "Remover" }))] })) }))] })) })) }));
};
